export function getPremium(hammerPrice: number, premiumPercentage: number) {
  if (hammerPrice < 0) {
    return 0;
  }

  return Number((hammerPrice * (premiumPercentage / 100)).toFixed(2));
}

export function getPriceBreakdown(
  hammerPrice: number,
  buyersPremiumPercentage: number,
  overheadPremiumPercentage: number
) {
  if (hammerPrice < 0) {
    return {
      hammerPrice: 0,
      buyersPremium: 0,
      overheadPremium: 0,
      total: 0,
    };
  }

  const buyersPremium = getPremium(hammerPrice, buyersPremiumPercentage);
  const overheadPremium = getPremium(hammerPrice, overheadPremiumPercentage);

  return {
    hammerPrice,
    buyersPremium,
    overheadPremium,
    total: hammerPrice + buyersPremium + overheadPremium,
  };
}
